// extracted by mini-css-extract-plugin
module.exports = {"root":"NotificationList_root__3FeAY"};